<div>
  <!-- Article state instructions -->
  @for (instruction of instructions; track instruction) {
    <ut-alert
      [type]="instruction.type"
      >
      {{ instruction.message }}
    </ut-alert>
  }

  <!-- Article header -->
  <div class="section-single-cover article">
    <div class="block container-fluid">
      <a
        class="feed-header-info"
        uiSref="profile.about"
        [uiParams]="{ profileId: article.user.slug }"
        [attr.aria-label]="'Article Author, ' + article.user.name"
        style="display: inline-block;"
        >
        <div class="feed-header-info-icon">
          <ut-avatar-badges [user]="article.user"></ut-avatar-badges>
        </div>
        <div class="feed-header-info-name" style="display: inline-block;">
          <span class="feed-header-info-name__text">{{ article.user.name }}</span>
          <br />
          <span class="time-stamp">{{ article.published_at | relativeDate }}</span>
        </div>
      </a>
      <ut-dynamic-tooltip [user]="article.user" tooltipType="user">
        <span
          tabindex="0"
          class="fa fa-info-circle"
          role="button"
          style="vertical-align: top;"
          [attr.aria-label]="'Open ' + article.user.name + ' tooltip'"
        ></span>
      </ut-dynamic-tooltip>
      <br />
      @if (article.current_user_permissions.update) {
        <a
          class="btn btn-rounded btn-filled small edit-article"
          uiSref="updatearticle"
          [uiParams]="{ articleId: article.id }"
          >
          edit
        </a>
      }
      <h1 [attr.aria-label]="(article.title | emojiText) + ', article by ' + article.user.name" [innerHTML]="article.title | emojiHtml"></h1>
      <br />
      <div class="tags" style="padding-top: 0; padding-bottom: 0;">
        @for (tag of article.tags; track $index) {
          <ut-tag-btn
            [tag]="tag"
          ></ut-tag-btn>
        }
      </div>
    </div>
  </div>

  <!-- Article toolbar -->
  <div class="container-fluid">
    <div class="section-single-toolbar">
      <div class="clearfix">
        <div class="section-single-toolbar__cell_left">
          <ut-community-feed-item-like-btn [likeable]="article"></ut-community-feed-item-like-btn>
          <ut-community-feed-item-like-count [likeable]="article"></ut-community-feed-item-like-count>
        </div>
        <div class="section-single-toolbar__cell_right">
          <ut-social-sharing
            [target]="article.url"
            [text]="article.title"
            type="Article"
          ></ut-social-sharing>
          <ut-community-feed-item-hide [item]="article" (stateChanged)="onArticleStateChanged()"></ut-community-feed-item-hide>
          <ut-community-feed-item-flag [item]="article"></ut-community-feed-item-flag>
          <ut-community-feed-item-subscribe [item]="article"></ut-community-feed-item-subscribe>
          <ut-community-archive-btn [item]="article" (stateChanged)="onArticleStateChanged()"></ut-community-archive-btn>
        </div>
      </div>
      <hr aria-hidden="true" />
    </div>
  </div>

  <!-- Article content -->
  <div class="section-single-body article">
    <div class="block container-fluid">
      <div class="section-single-body-content">
        <article [innerHTML]="processedContent"></article>
      </div>
      <ut-recommendations [items]="article.recommendations"></ut-recommendations>
    </div>
  </div>

  <!-- Comment section -->
  <ut-comment-section [service]="service" [commentable]="article"></ut-comment-section>
</div>
